import React from 'react';
import { T, fonts, layout } from '../../theme/tokens';

export function Btn({ children, primary, onClick, disabled, type = 'button' }) {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: "1rem",
        fontFamily: fonts.body,
        fontWeight: 600,
        fontSize: 15,
        letterSpacing: "0.5px",
        padding: primary ? "1.1rem 2.5rem" : "0.6rem 1.5rem",
        borderRadius: layout.radius,
        border: primary ? "none" : `1.5px solid ${T.accent}`,
        cursor: disabled ? "default" : "pointer",
        background: primary ? T.accent : "transparent",
        color: primary ? "#fff" : T.accent,
        opacity: disabled ? 0.5 : 1,
        transition: "transform .12s ease, background .12s ease",
      }}
      onMouseEnter={(e) => {
        if (!disabled) {
          if (primary) {
            e.currentTarget.style.background = T.accentDark;
            e.currentTarget.style.transform = "translateX(4px)";
          } else {
            e.currentTarget.style.background = T.accent;
            e.currentTarget.style.color = "#fff";
          }
        }
      }}
      onMouseLeave={(e) => {
        if (!disabled) {
          if (primary) {
            e.currentTarget.style.background = T.accent;
            e.currentTarget.style.transform = "translateX(0)";
          } else {
            e.currentTarget.style.background = "transparent";
            e.currentTarget.style.color = T.accent;
          }
        }
      }}
    >
      {children}
    </button>
  );
}
